module.exports = __webpack_public_path__ + "img/team-6.c9256104.png";